/* 🤖 this file was generated by svg-to-ts */
import { plIcon } from './pl-icon.model';
import { myIconArrowLeft } from './myIcon-arrow-left.icon';
import { myIconBadgeLifemap } from './myIcon-badge-lifemap.icon';
import { myIconBadgeSelfDiscovery } from './myIcon-badge-self-discovery.icon';
import { myIconBadgeStrengths } from './myIcon-badge-strengths.icon';
import { myIconBadgeTimeToReflect } from './myIcon-badge-time-to-reflect.icon';
import { myIconBriefcase } from './myIcon-briefcase.icon';
import { myIconCalendarAdd } from './myIcon-calendar_add.icon';
import { myIconCalendarMac } from './myIcon-calendar-mac.icon';
import { myIconCalendarOutlook } from './myIcon-calendar-outlook.icon';
import { myIconCertificateBlue } from './myIcon-certificate-blue.icon';
import { myIconCertificateGreen } from './myIcon-certificate-green.icon';
import { myIconChatboxEllipsesOutline } from './myIcon-chatbox-ellipses-outline.icon';
import { myIconCheckInvertedCircle } from './myIcon-check-inverted-circle.icon';
import { myIconChevronBack } from './myIcon-chevron-back.icon';
import { myIconChevronForward } from './myIcon-chevron-forward.icon';
import { myIconClose } from './myIcon-close.icon';
import { myIconExclamation } from './myIcon-exclamation.icon';
import { myIconEyeInvertedCircle } from './myIcon-eye-inverted-circle.icon';
import { myIconEyeOff } from './myIcon-eye-off.icon';
import { myIconEye } from './myIcon-eye.icon';
import { myIconGoogle } from './myIcon-google.icon';
import { myIconHeartWind } from './myIcon-heart-wind.icon';
import { myIconLockInvertedCircle } from './myIcon-lock-inverted-circle.icon';
import { myIconLock } from './myIcon-lock.icon';
import { myIconLogOut } from './myIcon-log-out.icon';
import { myIconMoon } from './myIcon-moon.icon';
import { myIconPauseCircle } from './myIcon-pause-circle.icon';
import { myIconPdf } from './myIcon-pdf.icon';
import { myIconPenToSquare } from './myIcon-pen-to-square.icon';
import { myIconPlLogo } from './myIcon-pl_logo.icon';
import { myIconPlayCircle } from './myIcon-play-circle.icon';
import { myIconStar } from './myIcon-star.icon';
import { myIconSun } from './myIcon-sun.icon';
import { myIconTick } from './myIcon-tick.icon';
import { myIconTime } from './myIcon-time.icon';
import { myIconVerified } from './myIcon-verified.icon';
import { myIconVideo } from './myIcon-video.icon';
export const completeIconSet: plIcon[] = [
  myIconArrowLeft as plIcon,
  myIconBadgeLifemap as plIcon,
  myIconBadgeSelfDiscovery as plIcon,
  myIconBadgeStrengths as plIcon,
  myIconBadgeTimeToReflect as plIcon,
  myIconBriefcase as plIcon,
  myIconCalendarAdd as plIcon,
  myIconCalendarMac as plIcon,
  myIconCalendarOutlook as plIcon,
  myIconCertificateBlue as plIcon,
  myIconCertificateGreen as plIcon,
  myIconChatboxEllipsesOutline as plIcon,
  myIconCheckInvertedCircle as plIcon,
  myIconChevronBack as plIcon,
  myIconChevronForward as plIcon,
  myIconClose as plIcon,
  myIconExclamation as plIcon,
  myIconEyeInvertedCircle as plIcon,
  myIconEyeOff as plIcon,
  myIconEye as plIcon,
  myIconGoogle as plIcon,
  myIconHeartWind as plIcon,
  myIconLockInvertedCircle as plIcon,
  myIconLock as plIcon,
  myIconLogOut as plIcon,
  myIconMoon as plIcon,
  myIconPauseCircle as plIcon,
  myIconPdf as plIcon,
  myIconPenToSquare as plIcon,
  myIconPlLogo as plIcon,
  myIconPlayCircle as plIcon,
  myIconStar as plIcon,
  myIconSun as plIcon,
  myIconTick as plIcon,
  myIconTime as plIcon,
  myIconVerified as plIcon,
  myIconVideo as plIcon,
];
